export const MediaDeviceErrors = {
  mediaBlocked: {
    title: 'Camera and microphone are blocked',
    body: 'Telnyx Meet requires access to your camera and microphone.',
  },
  allowMediaWarning: {
    title: 'Allow Telnyx Meet to use your camera and microphone',
    body: 'Telnyx Meet requires access to your camera and microphone to let other participants see and hear you.',
  },
};
